export const isDevelopmentMode = () => process.env.NEXT_PUBLIC_NODE_ENV === "development";
export const isProductionMode = () => process.env.NEXT_PUBLIC_NODE_ENV === "production";
export const getIrEnv = () => process.env.NEXT_PUBLIC_IR_ENV;
export const isProdIrEnv = () => getIrEnv() === "prod";
export const isLocalIrEnv = () => getIrEnv() === "local";
export  const isLocalHost = () => window.location.hostname === "localhost";
